import { Provider } from '@angular/core';
import { BREADCRUMB_ORIGINS, BreadcrumbOrigin } from '@services';

export function provideBreadcrumbOrigins(
  origins: Record<string, BreadcrumbOrigin>
): Provider[] {
  return [{ provide: BREADCRUMB_ORIGINS, useValue: origins }];
}
